define([
    "dojo/_base/declare",
    "csi/heading/BooleanController",
    "csi/locale",
    "csi/widget/MessageDialog",
    "csi/xml"
], function(declare,BooleanController,locale,MessageDialog,xml) {

    return declare(BooleanController, {
       
        /**
        * Returns a boolean based the set value that determines whether the prompt is display
        *
        * @param {Context} ctx the context of the object.
        * @return {boolean} true if the checkbox was set otherwise false
        */
        hasToConfirmAction: function() {
            // if its not published
           if(this._getCheckboxValue()){ // 
                return true;
           } else {
               return false;
           }
        },
        /**
         * Displays a Warning Prompt about potential load 
         * @params input object
         */
        confirmAction: function(/*Object*/params) {
            params = params || {};
            params.materialIcon = MessageDialog.ICON_WARNING;
            params.title = locale.typeAction("ExposeBOMSupplierAttributes", "ExposeBOMSupplierAttributesTitle");
            params.message = locale.typeAction("ExposeBOMSupplierAttributes", "ExposeBOMSupplierAttributesPrompt");
            params.buttons = [MessageDialog.BUTTON_OK, MessageDialog.BUTTON_CANCEL];
            this.inherited(arguments);
            
        },
        /**
         * onConfirm the checkbox is set to its new value
         * @param key 
         */
        onConfirm: function(key) {
            if (key == "OK") {
                this.process(true);
            } else {
                this.postProcess();
            }
        	
        }
    });
});